<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="enterpriseAdd" :model="formData" class="full-width-input" :rules="rules" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="企业名称" prop="EnterpriseInfo.enterpriseName">
            <el-input class="input-item" v-model="formData.EnterpriseInfo.enterpriseName"
                      :clearable="true" placeholder="企业名称"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="技术领域" prop="EnterpriseInfo.technologyField">
            <el-input class="input-item" v-model="formData.EnterpriseInfo.technologyField"
                      :clearable="true" placeholder="技术领域"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="联系方式" prop="EnterpriseInfo.contactInfo">
            <el-input class="input-item" v-model="formData.EnterpriseInfo.contactInfo"
                      :clearable="true" placeholder="联系方式"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="备注" prop="EnterpriseInfo.remark">
            <el-input class="input-item" v-model="formData.EnterpriseInfo.remark"
                      type="textarea"
                      :autosize="{minRows: 1, maxRows: 1}"
                      :clearable="true" placeholder="备注"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-row class="no-scroll flex-box" type="flex" justify="center">
            <el-button type="primary" :size="defaultFormItemSize" @click="onAddClick()">
              保存
            </el-button>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { EnterpriseInfoController } from '@/api';

export default {
  name: 'enterpriseAdd',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        EnterpriseInfo: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          enterpriseName: undefined,
          technologyField: undefined,
          contactInfo: undefined,
          remark: undefined,
          comment: {
          },
          isDatasourceInit: false
        }
      },
      rules: {
        'EnterpriseInfo.enterpriseName': [
          {required: true, message: '请输入企业名称', trigger: 'blur'}
        ],
        'EnterpriseInfo.technologyField': [
          {required: true, message: '请输入技术领域', trigger: 'blur'}
        ]
      },
      enterpriseAdd: {
        formFilter: {},
        formFilterCopy: {},
        menuBlock: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
       * 更新新增企业
       */
    refreshEnterpriseAdd (reloadData = false) {
      if (!this.enterpriseAdd.isInit) {
        // 初始化下拉数据
      }
      this.enterpriseAdd.isInit = true;
    },
    /**
       * 保存
       */
    onAddClick () {
      this.$refs.enterpriseAdd.validate((valid) => {
        if (!valid) return;
        let params = {
          enterpriseInfoDto: {
            enterpriseName: this.formData.EnterpriseInfo.enterpriseName,
            technologyField: this.formData.EnterpriseInfo.technologyField,
            contactInfo: this.formData.EnterpriseInfo.contactInfo,
            remark: this.formData.EnterpriseInfo.remark
          }
        };

        EnterpriseInfoController.add(this, params).then(res => {
          this.$message.success('保存成功');
          this.onCancel(true);
        }).catch(e => {});
      });
    },
    onResume () {
      this.refreshEnterpriseAdd(true);
    },
    initFormData () {
    },
    formInit () {
      this.refreshEnterpriseAdd();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
  }
}
</script>
